import { createContext } from 'react';

export interface ContextType {
  obfuscateAi: boolean;
}

export const PresentationPreferenceContext = createContext<ContextType | null>(null);

export const PresentationPreferenceProvider = ({
  children,
  obfuscateAi = false,
}: {
  children: React.ReactNode;
  obfuscateAi?: boolean;
}) => {
  return (
    <PresentationPreferenceContext.Provider value={{ obfuscateAi }}>{children}</PresentationPreferenceContext.Provider>
  );
};
